import { LogLevel } from '../types/LogLevel';

/**
 * @group Constants
 * 
 * @summary
 * <blockquote>Maps log levels to standard severity strings</blockquote>
 * 
 * @remarks
 * This mapping converts our internal log levels to standard severity strings
 * used by external logging services (e.g., Sentry uses 'warning' instead of 'warn').
 * 
 * Common mappings:
 * - error → 'error'
 * - warn → 'warning'
 * - info → 'info'
 * - debug → 'debug'
 * - none → 'info' (fallback)
 * 
 * @example
 * ```typescript
 * import { LOG_SEVERITY_MAP } from '@shared/config';
 * 
 * const severity = LOG_SEVERITY_MAP['warn']; // 'warning'
 * ```
 */
export const LOG_SEVERITY_MAP: Record<LogLevel, string> = {
  error: 'error',
  warn: 'warning',
  info: 'info',
  debug: 'debug',
  none: 'info', // Fallback to 'info' for 'none' level
} as const;

